<template>
  <div id="application">
    <v-card class="mt-2">
      <v-card-title class="subtitle-1"
        >{{ $t("labels.CLI_Insurance") }}
        <v-btn dark x-small color="primary" @click="getQuote()" class="ml-4">{{
          $t("labels.CLI_GetQuote")
        }}</v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col lg="3" sm="6" md="3">
            <v-row no-gutters>
              <span class="font-weight-black required">{{
                $t("labels.CLI_CoverageTypes")
              }}</span>
            </v-row>
          </v-col>
          <v-col
            lg="4"
            sm="6"
            md="4"
            v-for="item in applicants"
            v-bind:key="item.ApplicatId"
          >
            <span class="font-weight-black" v-if="item.PrimaryFl"
              >{{ item.FirstName }} {{ item.LastName }}</span
            >
            <span class="font-weight-black" v-if="!item.PrimaryFl"
              >{{ item.FirstName }} {{ item.LastName }}</span
            >
          </v-col>
        </v-row>
        <v-row
          v-for="(item, index) in applicants[0].InsuranceTypes"
          v-bind:key="item.Code"
        >
          <v-col lg="3" sm="6" md="3"></v-col>
          <v-col
            lg="4"
            sm="6"
            md="4"
            v-for="applicant in applicants"
            v-bind:key="applicant.ApplicantId"
          >
            <v-row>
              <v-col lg="6" sm="6" md="6">
                <!-- :disabled="applicant.InsuranceTypes[index].DisabledFl"                          -->
                <v-checkbox
                  class="mt-0"
                  v-model="applicant.InsuranceTypes[index].SelectedFl"
                  :label="$t('labels.CLI_InsuranceType_' + item.Code)"
                  hide-details
                  @change="coverageSelected(applicant, item.Code)"
                ></v-checkbox>
              </v-col>
              <v-col>
                <span
                  v-if="
                    item.Code !== 'AD' ||
                    (item.Code === 'AD' && item.MonthlyPremium > 0)
                  "
                  >{{ getPremiumAmount(item.Code, applicant) | currency }} /
                  {{ getFrequency() }}</span
                >
                <span
                  class="text-center"
                  v-else-if="item.Code === 'AD' && item.MonthlyPremium === 0"
                  >{{ $t("labels.CLI_NotAvailable") }}</span
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col lg="3" sm="6" md="3"></v-col>
          <v-col
            lg="4"
            sm="6"
            md="4"
            v-for="applicant in applicants"
            v-bind:key="applicant.ApplicatId"
          >
            <v-row>
              <v-col lg="6" sm="6" md="6">
                <span class="font-weight-black">{{
                  $t("labels.TotalIfLife")
                }}</span>
              </v-col>
              <v-col>
                <span
                  >{{ totalPremium[applicant.ApplicantId] | currency }} /
                  {{ getFrequency() }}</span
                >
              </v-col>
            </v-row>
            <v-row v-if="displayDecline(applicant)">
              <v-col lg="6" sm="6" md="6">
                <span class="font-weight-black">{{
                  $t("labels.TotalNotLife")
                }}</span>
              </v-col>
              <v-col>
                <span
                  >{{ getPremiumAmount("AD", applicant) | currency }} /
                  {{ getFrequency() }}</span
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters class="mt-4">
          <span v-html="$t('messages.CLI_InsuranceCoverageOptions')"></span>
        </v-row>
        <v-row no-gutters class="mt-2">
          <span class="font-weight-bold">{{
            $t("messages.CLI_InsuranceCoverageSelectionOptions")
          }}</span>
        </v-row>
        <v-row no-gutters class="mt-4">
          <span v-html="$t('messages.CLI_CoverageAmountText')"></span>
        </v-row>
        <v-row class="mt-4">
          <v-col lg="3" sm="6" md="4">
            <v-btn
              color="primary"
              @click="changeCoverageAmount()"
              :disabled="!partialCoverageEditableFl"
              class="ml-4"
              v-show="!hideCoverageAmountButton"
              >{{ $t("labels.CLI_CoverageAmount") }}
              {{ insuranceDetail.CoverageAmount | currency }}</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col lg="3" sm="6" md="4">
            <v-currency-field
              v-show="showCoverageAmount"
              v-model="insuranceDetail.CoverageAmount"
              :label="$t('labels.CLI_CoverageAmount')"
              required
              :disabled="!partialCoverageEditableFl"
              @blur="coverageAmountChanged()"
            ></v-currency-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col lg="3" sm="6" md="4">
            <p class="ml-4">
              <strong>{{ $t("labels.CLI_PartialCoveragePercentage") }}</strong>
              {{ insuranceDetail.PartialCoveragePercentage + "%" }}
            </p>
          </v-col>
        </v-row>

        <v-row class="mt-3">
          <v-col lg="3" sm="6" md="3">
            <v-row no-gutters>
              <span class="font-weight-black required" v-show="false">{{
                $t("labels.CLI_CoverageTypes")
              }}</span>
            </v-row>
          </v-col>
          <v-col
            lg="4"
            sm="6"
            md="4"
            v-for="item in applicants"
            v-bind:key="item.ApplicatId"
          >
            <span class="font-weight-black" v-if="item.PrimaryFl"
              >{{ item.FirstName }} {{ item.LastName }}</span
            >
            <span class="font-weight-black" v-if="!item.PrimaryFl"
              >{{ item.FirstName }} {{ item.LastName }}</span
            >
          </v-col>
        </v-row>
        <v-row class="mb-3">
          <v-col lg="3" sm="6" md="3"></v-col>
          <v-col
            lg="4"
            sm="6"
            md="4"
            v-for="applicant in applicants"
            v-bind:key="applicant.ApplicatId"
          >
            <v-checkbox
              v-model="applicant.DeclinedFl"
              :label="$t('labels.CLI_DeclinedOfferedCoverage')"
              hide-details
              @change="coverageDeclined(applicant)"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import money from "v-money";
export default {
  props: [
    "insuranceDetail",
    "loanDetail",
    "applicants",
    "generateApplicationFl",
  ],
  data() {
    return {
      isSubmitted: false,
      partialCoverageEditableFl: false,
      showCoverageAmount: false,
      hideCoverageAmountButton: false,
      totalPremium: {},
      currency_config: {
        decimal: ".",
        thousands: ",",
        prefix: "R$ ",
        precision: 2,
        masked: false,
        allowBlank: true,
        default: null,
        min: 250000,
        max: Number.MAX_SAFE_INTEGER,
      },
    };
  },
  computed: {},
  created() {
    for (let index = 0; index < this.applicants.length; index++) {
      let applicant = this.applicants[index];
      for (let cindex = 0; cindex < applicant.InsuranceTypes.length; cindex++) {
        let insuranceType = applicant.InsuranceTypes[cindex];
        insuranceType.DisabledFl = insuranceType.Code === "AD";
      }
    }
    this.setTotalPreimumAmount();
    this.partialCoverageEditableFl = this.loanDetail.LoanAmount > 250000;
  },
  mounted() {},
  methods: {
     displayDecline(applicant){
       let lifeInsurance = applicant.InsuranceTypes.filter(function (it) {
        return it.Code.toUpperCase() === "LI";
      })[0];
      let accidentalDeathInsurance = applicant.InsuranceTypes.filter(function (
        it
      ) {
        return it.Code.toUpperCase() === "AD";
      })[0];  
       let accidental = applicant.InsuranceTypes.filter(x => x.Code == accidentalDeathInsurance.Code);
      let lifeIns = applicant.InsuranceTypes.filter(x => x.Code == lifeInsurance.Code);
      if(accidental[0].SelectedFl && lifeIns[0].SelectedFl){
         return true;
      }
      return false;
    },
    getFrequency() {
      switch (this.loanDetail.PaymentFrequencyId) {
        case 0:
          return this.$t("labels.CLI_Month");

        case 1:
          return this.$t("labels.CLI_Semi_Month");

        case 2:
          return this.$t("labels.CLI_Bi_weekly");

        case 3:
          return this.$t("labels.CLI_Bi_weekly");

        case 4:
          return this.$t("labels.CLI_weekly");

        case 5:
          return this.$t("labels.CLI_weekly");
      }
    },
    getQuote() {
      this.$emit("getQuote");
    },
    changeCoverageAmount() {
      this.showCoverageAmount = true;
      this.hideCoverageAmountButton = true;
    },
    coverageDeclined(applicant) {
      applicant.InsuranceTypes.forEach((coverageType) => {
        coverageType.SelectedFl = !applicant.DeclinedFl;
        if (coverageType.Code == "AD") {
          coverageType.SelectedFl = false;
          coverageType.DisabledFl = true;
        }
        this.setTotalPreimumAmount();
      });

      this.$emit("coverageChanged");
    },
    setTotalPreimumAmount() {
      this.applicants.forEach((applicant) => {
        this.totalPremium[applicant.ApplicantId] = 0;
        applicant.InsuranceTypes.forEach((coverageType) => {
          if (coverageType.SelectedFl) {
            this.totalPremium[applicant.ApplicantId] += this.getPremiumAmount(
              coverageType.Code,
              applicant
            );
          }
        });
      
      let lifeInsurance = applicant.InsuranceTypes.filter(function (it) {
        return it.Code.toUpperCase() === "LI";
      })[0];
      let accidentalDeathInsurance = applicant.InsuranceTypes.filter(function (
        it
      ) {
        return it.Code.toUpperCase() === "AD";
      })[0];
      let accidental = applicant.InsuranceTypes.filter(
        (x) => x.Code == accidentalDeathInsurance.Code
      );
      let lifeIns = applicant.InsuranceTypes.filter(
        (x) => x.Code == lifeInsurance.Code
      );
      if (accidental[0].SelectedFl && lifeIns[0].SelectedFl) {
        this.totalPremium[applicant.ApplicantId] =
          this.totalPremium[applicant.ApplicantId] -
          this.getPremiumAmount(accidental[0].Code, applicant);
      }

      });
    },
    coverageSelected(applicant, code) {
      let lifeInsurance = applicant.InsuranceTypes.filter(function (it) {
        return it.Code.toUpperCase() === "LI";
      })[0];
      let criticalInsurance = applicant.InsuranceTypes.filter(function (it) {
        return it.Code.toUpperCase() === "CI";
      })[0];

      let accidentalDeathInsurance = applicant.InsuranceTypes.filter(function (
        it
      ) {
        return it.Code.toUpperCase() === "AD";
      })[0];

      let currentItem = applicant.InsuranceTypes.filter(function (it) {
        return it.Code.toUpperCase() === code;
      })[0];

      if (currentItem.SelectedFl && code === criticalInsurance.Code) {
        lifeInsurance.SelectedFl = true;
        accidentalDeathInsurance.SelectedFl = false;
        accidentalDeathInsurance.DisabledFl = true;
      }

      if (!currentItem.SelectedFl && code === lifeInsurance.Code) {
        criticalInsurance.SelectedFl = false;
      }

      if (currentItem.SelectedFl && code === lifeInsurance.Code) {
        accidentalDeathInsurance.SelectedFl = false;
        accidentalDeathInsurance.DisabledFl = true;
      }

      if (!currentItem.SelectedFl && code === lifeInsurance.Code) {
        accidentalDeathInsurance.SelectedFl = false;
        accidentalDeathInsurance.DisabledFl = false;
      }

      this.setTotalPreimumAmount();

      applicant.DeclinedFl = !applicant.InsuranceTypes.some(function (item) {
        return item.SelectedFl;
      });

      this.$emit("coverageChanged");
    },
    coverageAmountChanged() {
      const Minimum_Insurance_Amount = 250000;
      var loanAmount = this.loanDetail.LoanAmount;

      if (
        !this.partialCoverageEditableFl ||
        isNaN(this.insuranceDetail.CoverageAmount) ||
        this.insuranceDetail.CoverageAmount > loanAmount
      ) {
        this.insuranceDetail.CoverageAmount = loanAmount;
      }

      if (
        this.insuranceDetail.CoverageAmount < Minimum_Insurance_Amount &&
        loanAmount >= Minimum_Insurance_Amount
      ) {
        this.insuranceDetail.CoverageAmount = Minimum_Insurance_Amount;
      }

      //     const formatter = new Intl.NumberFormat('en-CA', {
      //             style: 'currency',
      //             currency: 'CAD',
      //             minimumFractionDigits: 2
      //             })

      this.insuranceDetail.CoverageAmount =
        Math.round(
          (parseFloat(this.insuranceDetail.CoverageAmount) + Number.EPSILON) *
            100
        ) / 100;
      this.insuranceDetail.PartialCoveragePercentage = Math.floor(
        (this.insuranceDetail.CoverageAmount / loanAmount) * 100
      );
      this.getQuote();
    },
    getPremiumAmount(code, applicant) {
      var coverageTypes = applicant.InsuranceTypes.filter(function (item) {
        return item.Code === code;
      });

      return coverageTypes.length > 0 ? coverageTypes[0].MonthlyPremium : 0;
    },
  },
};
</script>
<style scoped>
</style>